
import { WorkoutForm } from "@/components/workouts/WorkoutForm";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useMobileMenu } from "@/components/dashboard/header/useMobileMenu";
import { useTranslations } from "@/hooks/useTranslations";
import { useLanguagePath } from "@/utils/language";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const EditWorkout = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { closeMenu } = useMobileMenu();
  const { t } = useTranslations("workouts");
  const { getPath } = useLanguagePath();
  
  const { data: workout, isLoading } = useQuery({
    queryKey: ["workout-details", id],
    queryFn: async () => {
      if (!id) return null;
      const { data, error } = await supabase
        .from("workouts")
        .select("*")
        .eq("id", id)
        .single();
      
      if (error) throw error;
      return data;
    },
    enabled: !!id,
  });
  
  const handleBack = () => {
    closeMenu();
    navigate(getPath("/dashboard/workouts"));
  };
  
  return (
    <div className="space-y-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight gradient-text text-slate-950">
            {t("editWorkout.title")}
          </h2>
          <p className="text-muted-foreground">
            {t("editWorkout.subtitle")}
          </p>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/dashboard")} className="text-flame hover:text-flame/80">
                  Dashboard
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink href={getPath("/dashboard/workouts")} className="text-flame hover:text-flame/80">
                  {t("title")}
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium">
                  {isLoading ? "..." : workout?.title || t("editWorkout.title")}
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
        <Button variant="outline" onClick={handleBack} className="mt-2 md:mt-0">
          <ArrowLeft className="mr-2 h-4 w-4" />
          {t("actions.back")}
        </Button>
      </div>

      <div className="bg-transparent">
        <WorkoutForm />
      </div>
    </div>
  );
};

export default EditWorkout;
